import { render, staticRenderFns } from "./Produtos.vue?vue&type=template&id=4096b455&scoped=true&"
import script from "./Produtos.vue?vue&type=script&lang=ts&"
export * from "./Produtos.vue?vue&type=script&lang=ts&"
import style0 from "./Produtos.vue?vue&type=style&index=0&id=4096b455&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4096b455",
  null
  
)

export default component.exports